import React from 'react';
import Select from 'react-select';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {BoldPrimaryButton, PrimaryButton, SecondaryButton} from '../../common/Button';
import {Label} from '../../common/StyledComponents';
import countryGroupMessages from '../../../intl/common/countryGroupMessages';
import authManagementMessages from '../../../intl/admin/rightsManagementMessages';
import buttonMessages from '../../../intl/common/buttonMessages';
import adminMessages from '../../../intl/admin/adminMessages';

const SelectAdminCountries = props => {
    const {
        adminData, intl: {formatMessage}, selectedOptions, countriesChanged, handleCountrySelectionChange,
        handleAllCountriesClick, handleSaveClick, handleCancelClick
    } = props;
    const options = Object.keys(adminData || {})
        .map(countryIso => ({
            value: countryIso,
            label: countryGroupMessages[countryIso] ? formatMessage(countryGroupMessages[countryIso]) : countryIso
        }));
    const formattedSelectedOptions = (selectedOptions || []).map(countryIso => ({
        value: countryIso.value,
        label: countryGroupMessages[countryIso.value] ? formatMessage(countryGroupMessages[countryIso.value]) : countryIso.value
    })).sort((option1, option2) => option1.value.localeCompare(option2.value));

    return (
        <div className="container-fluid">
            <div className="row mb-sm-2">
                <div className="col-sm-12">
                    <Label>
                        <FormattedMessage {...adminMessages.SELECT_COUNTRIES}/>
                    </Label>
                    <PrimaryButton type="button" className="btn btn-sm ml-sm-3" onClick={handleAllCountriesClick}>
                        <FormattedMessage {...buttonMessages.ALL}/>
                    </PrimaryButton>
                </div>
            </div>
            <div className="row mb-sm-3">
                <div className="col">
                    <Select isMulti isSearchable
                            value={formattedSelectedOptions}
                            options={options}
                            placeholder={formatMessage(authManagementMessages.SELECT_COUNTRIES_PLACEHOLDER)}
                            onChange={handleCountrySelectionChange}/>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-6">
                    <SecondaryButton type="button"
                                     disabled={!countriesChanged}
                                     className="btn float-right"
                                     onClick={handleCancelClick}>
                        <FormattedMessage {...buttonMessages.CANCEL}/>
                    </SecondaryButton>
                </div>
                <div className="col-sm-6">
                    <BoldPrimaryButton type="button" className="btn float-left"
                                       disabled={!countriesChanged}
                                       onClick={handleSaveClick}>
                        <FormattedMessage {...buttonMessages.SAVE}/>
                    </BoldPrimaryButton>
                </div>
            </div>
        </div>
    );
};

SelectAdminCountries.propTypes = {
    adminData: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    selectedOptions: PropTypes.array,
    countriesChanged: PropTypes.bool.isRequired,
    handleCountrySelectionChange: PropTypes.func.isRequired,
    handleAllCountriesClick: PropTypes.func.isRequired,
    handleSaveClick: PropTypes.func.isRequired,
    handleCancelClick: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    adminData: state.adminRightsManagement.adminData,
    selectedOptions: state.adminRightsManagement.selectedAdminOptions,
    countriesChanged: state.adminRightsManagement.adminCountriesChanged
});

export default connect(mapStateToProps, {})(injectIntl(SelectAdminCountries))
